import { render, staticRenderFns } from "./TabMemberInformation.vue?vue&type=template&id=95454604"
import script from "./TabMemberInformation.vue?vue&type=script&lang=js"
export * from "./TabMemberInformation.vue?vue&type=script&lang=js"
import style0 from "./TabMemberInformation.vue?vue&type=style&index=0&id=95454604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports